import { TableField, defaultDateFormatter } from "../../table-field";

export const fieldsLegislacao: TableField[] = [
  {
    key: "IdEntrega",
    label: "ID",
    tdClass: ["align-middle", "naoQuebrar", "text-left", "text-xl-center"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: true,
  },
  {
    key: "Situacao",
    label: "Situação",
    tdClass: ["align-middle", "quebrarPorPalavra", "text-left", "text-xl-center"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: true,
  },
  {
    key: "Exercicio",
    label: "Exercício",
    tdClass: ["align-middle", "naoQuebrar", "text-left", "text-xl-center"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: true,
  },
  {
    key: "DataEntrega",
    label: "Data de envio",
    tdClass: ["align-middle", "naoQuebrar", "text-left", "text-xl-center"],
    thClass: ["text-center", "quebrarPorPalavra"],
    sortable: true,
    formatter: defaultDateFormatter,
  },
  {
    key: "Tipo",
    label: "Tipo",
    tdClass: ["align-middle", "quebrarPorPalavra", "text-left", "text-xl-center"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: true,
  },
  {
    key: "QtdDocumentos",
    label: "Qtd\u00A0documentos",
    tdClass: ["align-middle", "naoQuebrar", "text-left", "text-xl-center"],
    thClass: ["text-center", "quebrarPorPalavraHard"],
     thStyle: { minWidth: "100px" },
    sortable: true,
  },
  {
    key: "actions",
    label: "Ações",
    tdClass: ["align-middle", "col-actions", "text-left", "text-xl-center"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: false,
  },
];
